import { useAsync, useMountEffect } from "@react-hookz/web";
import camelcaseKeys from "camelcase-keys";
import { fetchQuery, graphql, useRelayEnvironment } from "react-relay";

import { config } from "~/data";
import type { acquisitionConfigAppConfigQuery } from "~/queries/__generated__/acquisitionConfigAppConfigQuery.graphql";

export const useAcquisitionConfig = () => {
  const environment = useRelayEnvironment();
  const [state, actions] = useAsync(async () => {
    const data = await fetchQuery<acquisitionConfigAppConfigQuery>(
      environment,
      graphql`
        query acquisitionConfigAppConfigQuery {
          appConfig(filter: { entityId: "acquisition" }) {
            json
          }
        }
      `,
      {},
      {
        fetchPolicy: "store-or-network",
      },
    ).toPromise();

    if (!data?.appConfig?.json) return;
    const raw = camelcaseKeys(data.appConfig.json, { deep: true }) as AcquisitionConfigs;
    return config.general.env === "production" ? raw.production : raw.dev;
  });

  useMountEffect(() => {
    void actions.execute();
  });
  return { acquisitionConfigState: state };
};

type AcquisitionConfigs = {
  dev: AcquisitionConfig;
  production: AcquisitionConfig;
};
type AcquisitionConfig = {
  styleStoryCarousel: {
    display: boolean;
  };
  tooltip: {
    message: string;
    version: string;
  };
} & Record<
  string,
  {
    list: { id: string; trackingEventLabel: string }[];
    name: string;
  }
>;
